import React from 'react';
import { Icon } from './Icon.js';
export const IconCircleLockFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M9,1C4.589,1,1,4.589,1,9s3.589,8,8,8,8-3.589,8-8S13.411,1,9,1Zm.75,9.362v2.138c0,.414-.336,.75-.75,.75s-.75-.336-.75-.75v-2.138c-.872-.31-1.5-1.134-1.5-2.112,0-1.243,1.007-2.25,2.25-2.25s2.25,1.007,2.25,2.25c0,.978-.628,1.802-1.5,2.112Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconCircleLockFill18.js.map